import React from 'react';
import { CardSubtitle } from 'reactstrap';
import { UncontrolledTable } from '~/components';
import usePatient from '~/utils/patient/hook';
import { MatchStatus } from '~/utils/const/identity';

const Hearing = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <>
      <CardSubtitle tag="h5" className="m-3">
        Hearing
      </CardSubtitle>

      <UncontrolledTable
        name="hearing"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-visionhearingscreen',
          params: {
            screentype: 'hearing',
            sacwis_id: sacwisId,
            match_status_id: MatchStatus.Approved,
            'all-data': '1',
          },
        }}
        defaultSorted={[{ id: 'dispname', desc: true }]}
        columns={[
          {
            id: 'dispname',
            Header: 'Exam Details',
            accessor: 'attributes.dispname',
          },
          {
            id: 'measvalue',
            Header: 'Results',
            accessor: 'attributes.measvalue',
          },
          {
            id: 'recordedtimeTs',
            Header: 'Date',
            accessor: 'attributes.recordedtimeTs',
            cellType: 'date',
          },
          {
            id: 'sourceDescription',
            Header: 'Reporting Healthcare Insitution',
            accessor: 'attributes.sourceDescription',
          },
        ]}
      />
      <p className="mt-3 text-muted">
        <em>
          **A hearing screen is considered to be normal when a child can detect
          every frequency (HZ) at 20-dB in both ears. Detection at higher than
          20-dB at any frequency in either ear may be abnormal.
        </em>
      </p>
    </>
  );
};

export default Hearing;
